import Nullable from "@/types/utils/Nullable"
import { useEffect, useRef, useState } from "react"
import { formatCEP, formatPrice, isCEP, isName, isTelephoneNumber } from "@/utils/validation"
import InputWithValidation from "@/components/inputs/inputWithValidation"
import {GET_OFFER_TYPE, IParcelamentoOptions, SET_OFFER_VALUE} from "@/store/slices/offerSlice";
import Select from "@/components/Select"
import Button from "@/components/inputs/button"
import Events from "@/utils/Events";
import { useDispatch, useSelector} from 'react-redux'
import { GET_ALL_STATE, GET_USER_STEP, SET_LOADING, SET_MODAL, SET_USER_STEP } from "@/store/slices/appSlice"
import dicasEntrega from './dicasEntrega.json'
import { GET_OFFER } from "@/store/slices/offerSlice"
import { GET_USER_ADDRESS, SET_USER_ADDRESS, GET_USER } from "@/store/slices/userSlice";
import Lead from "@/utils/Lead";

import styled from "styled-components";
import { getAddress } from "@/api/endereco";

import { registrarMultiplosHistoricos } from "@/api/enriquecimentoDados";

export const Row = styled.div`
  display: flex;
  gap: 10px;
`;

export const Col = styled.div<{ width: string }>`
  width: ${({ width }) => width};
`;

const ufs = [
    'UF', 'AC', 'AL', 'AM', 'AP', 'BA', 'CE', 'DF', 'ES', 'GO', 'MA', 'MG',
    'MS', 'MT', 'PA', 'PB', 'PE', 'PI', 'PR', 'RJ', 'RN', 'RO',
    'RR', 'RS', 'SC', 'SE', 'SP', 'TO'
  ];

  const entregaOptions: IParcelamentoOptions[] = Object.entries(dicasEntrega).map(([value, texto]) => ({
    value,
    texto,
  }));
const Endereco = () => {
    const oferta = useSelector(GET_OFFER)
    const user = useSelector(GET_USER)
    const [cep, setCep] = useState<string>('')
    const [cepErrorMessage, setCepErrorMessage] = useState<Nullable<string>>(null)
    const [initialValueRef, setInitialValueRef] = useState(oferta.valor?.valor || oferta.valor?.original)
    const [cidade, setCidade] = useState('')
    const [cidadeErrorMessage, setCidadeErrorMessage] = useState<Nullable<string>>(null)
    const [bairro, setBairro] = useState('')
    const [bairroErrorMessage, setBairroErrorMessage] = useState<Nullable<string>>(null)
    const [endereco, setEndereco] = useState<string>('')
    const [enderecoErrorMessage, setEnderecoErrorMessage] = useState<Nullable<string>>(null)
    const [numeroErrorMessage, setNumeroErrorMessage] = useState<Nullable<string>>(null)
    const [numero, setNumero] = useState('')
    const [complemento, setComplemento] = useState('')
    const [uf, setUf] = useState<string>('UF')
    const [ufErrorMessage, setUfErrorMessage] = useState<Nullable<string>>(null)
    const [referencia, setReferencia] = useState('')
    const [entrega] = useState<IParcelamentoOptions[]>(entregaOptions)
    const [entregaSelecionada, setEntregaSelecionada] = useState('');
    const [descricao, setDescricao] = useState('');
    const [autoFilled, setAutoFilled] = useState({ endereco: false, bairro: false, cidade: false, uf: false });
    const address = useSelector(GET_USER_ADDRESS)
    const events = new Events();
    const states = useSelector(GET_ALL_STATE)
    const dispatch = useDispatch()
    const step = useSelector(GET_USER_STEP)
    const [all_states, setAllStates] = useState(states)
    const offer_type = useSelector(GET_OFFER_TYPE)

    useEffect(() => {
        setAllStates(states) 
    }, [states]);


    const clean = (type?: string, value?: string) => {
        const resetInputs = () => {
          setAutoFilled({ endereco: false, bairro: false, cidade: false, uf: false });
          setCep('');
          setBairro('');
          setCidade('');
          setUf('UF');
          setEndereco('');
        };
      
        const resetAddressErrors = () => {
          setCepErrorMessage(null);
          setBairroErrorMessage(null);
          setCidadeErrorMessage(null);
          setUfErrorMessage(null);
          setNumeroErrorMessage(null);
          setEnderecoErrorMessage(null);
        };
      
        const resetAllErrors = () => {
          resetAddressErrors();
        };
      
        if (type === 'address') {
          if (value === 'inputs') return resetInputs();
          if (value === 'errors') return resetAddressErrors();
      
          resetInputs();
          return resetAddressErrors();
        }
      
        resetAllErrors();
      };

      useEffect(() => {
        const cepLimpo = cep.replace(/\D/g, '').trim();
        if (cepLimpo.length < 8) {
            clean('address', 'inputs');
            return;
        }
      
        const carregarDados = async () => {
          dispatch(SET_LOADING(true));
      
          try {
            const response = await getAddress(oferta?.cd_oferta,formatCEP(cep));
            if (response.erro || response.escr === "") {
              dispatch(SET_MODAL({ show: true, type: 'impossibilidade' }));
              clean('address');
              return;
            }

            const { valor, escr, logradouro, bairro, localidade, uf } = response;

            dispatch(SET_USER_ADDRESS({...address , escritorio: Number(escr) }))

            if (valor && valor !== "0" && initialValueRef != null) {

            const oldPrice = formatPrice(initialValueRef);
            const newPrice = formatPrice(oferta?.escadinha ? oferta?.escadinha?.[escr || 1000]?.valor :  valor);
            console.log('newPrice', newPrice)
            console.log('oldPrice', oldPrice)
            if (newPrice !== oldPrice) {
                dispatch(SET_OFFER_VALUE(newPrice));

                dispatch(SET_MODAL({
                show: true,
                type: 'mudanca-preco',
                price: { oldPrice, newPrice }
                }));

                setInitialValueRef(Number(newPrice.replace(',', '.')));
            }

            } 

            clean('address', 'errors'); 

            const newAutoFilled = {
              endereco: !!logradouro,
              bairro: !!bairro,
              cidade: !!localidade,
              uf: !!uf,
            };
            setAutoFilled(newAutoFilled);

            setUf(uf || 'UF');
            setBairro(bairro);
            setEndereco(logradouro);
            setCidade(localidade);
      
          } catch (error) {
            dispatch(SET_MODAL({ show: true, type: 'impossibilidade' }));
            clean('address');
          } finally {
            dispatch(SET_LOADING(false));
          }
        };
      
        carregarDados();
      }, [cep]);
      

    const saveToState = async (event: any) => {
        event.preventDefault()

        let erroNoFormulario: boolean = false
        if(!isCEP(cep)){
            erroNoFormulario = true
            events.trigger('endereco_entrega_cep_erro', { offer_type })
            setCepErrorMessage('CEP inválido')
        }
        if(endereco.length < 3){
            erroNoFormulario = true
            events.trigger('endereco_entrega_rua_erro', { offer_type })
            setEnderecoErrorMessage('Endereço inválido')
        }  
        if(bairro.length < 3){
            erroNoFormulario = true
            events.trigger('endereco_entrega_bairro_erro', { offer_type })
            setBairroErrorMessage('Bairro inválido')
        }
        if(!uf || uf === 'UF'){
            erroNoFormulario = true
            events.trigger('endereco_entrega_uf_erro', { offer_type })
            setUfErrorMessage('UF inválido')
        }
        if(!numero){
          erroNoFormulario = true
          events.trigger('endereco_entrega_numero_erro', {offer_type})
          setNumeroErrorMessage('Nº obrigatório')
        }
        if(!cidade){
            erroNoFormulario = true
            events.trigger('endereco_entrega_cidade_erro', { offer_type })
            setCidadeErrorMessage('Cidade obrigatório')
        }      
 
        if(erroNoFormulario){
            return
        }
        clean()
        erroNoFormulario = false

        dispatch(SET_USER_ADDRESS({
            ...address, 
            bairro: bairro,
            cep: cep,
            cidade: cidade,
            numero: Number(numero),
            logradouro: endereco,
            complemento: complemento.trim().replace(/\s+/g, ' '),
            pais: 'BRASIL',
            sigla_pais: 'BR',
            uf: uf,
            ponto_ref: referencia.trim().replace(/\s+/g, ' '),
            dica_entrega: entregaSelecionada,
            dica_entrega_input: descricao.trim().replace(/\s+/g, ' '),
          }));

        try {
            registrarMultiplosHistoricos([
                {
                    usuario_id: user.id_usuario,
                    campo_alterado: "cep",
                    origem_alteracao: "ASSINE_3_formulario_endereco",
                    valor_novo: cep,
                },
                {
                    usuario_id: user.id_usuario,
                    campo_alterado: "logradouro",
                    origem_alteracao: "ASSINE_3_formulario_endereco",
                    valor_novo: endereco,
                },
                {
                    usuario_id: user.id_usuario,
                    campo_alterado: "bairro",
                    origem_alteracao: "ASSINE_3_formulario_endereco",
                    valor_novo: bairro,
                },
                {
                    usuario_id: user.id_usuario,
                    campo_alterado: "cidade",
                    origem_alteracao: "ASSINE_3_formulario_endereco",
                    valor_novo: cidade,
                },
                {
                    usuario_id: user.id_usuario,
                    campo_alterado: "uf",
                    origem_alteracao: "ASSINE_3_formulario_endereco",
                    valor_novo: uf,
                },
                {
                    usuario_id: user.id_usuario,
                    campo_alterado: "numero",
                    origem_alteracao: "ASSINE_3_formulario_endereco",
                    valor_novo: numero,
                },
            ]);
        } catch {}

          Lead.save(all_states.lead.value, dispatch)
          dispatch(SET_USER_STEP(step + 1))

    }
    return <form onSubmit={saveToState}>
        <InputWithValidation
            name="cep"
            id="cep"
            type="text"
            placeholder="CEP"
            onChange={setCep}
            errorMessage={cepErrorMessage}
            value={cep}
            OnClick={()=> {
                events.trigger("endereco_entrega_cep", { offer_type }),
                setCepErrorMessage(null)
            }}
        />
        <Row>
            <Col width="80%">
                <InputWithValidation
                    name="endereco"
                    id="endereco"
                    type="text"
                    placeholder="Endereço"
                    value={endereco}
                    onChange={setEndereco}
                    disabled={autoFilled.endereco}
                    errorMessage={enderecoErrorMessage}
                    OnClick={()=> {
                        events.trigger("endereco_entrega_rua", { offer_type }),
                        setEnderecoErrorMessage(null)
                    }}
                />
            </Col>
            <Col width="20%">
                <InputWithValidation
                    name="num"
                    id="num"
                    type="text"
                    placeholder="N°"
                    onChange={setNumero}
                    errorMessage={numeroErrorMessage}
                    value={numero}
                    OnClick={()=> {
                        events.trigger("endereco_entrega_numero", { offer_type }),
                        setNumeroErrorMessage(null)
                    }}
                />
            </Col>
        </Row>
        <Row>
            <Col width="40%">
                <InputWithValidation
                        name="complemento"
                        id="complemento"
                        type="text"
                        placeholder="Complemento"
                        maxLenght={25}
                        onChange={setComplemento}
                        errorMessage={null}
                        value={complemento}
                        OnClick={()=> {
                            events.trigger("endereco_entrega_complemento", { offer_type })
                        }}
                    /> 
            </Col>
            <Col width="60%">
                <InputWithValidation
                    name="bairro"
                    id="bairro"
                    type="text"
                    value={bairro}
                    placeholder="Bairro"
                    onChange={setBairro}
                    disabled={autoFilled.bairro}
                    errorMessage={bairroErrorMessage}
                    OnClick={()=> {
                        events.trigger("endereco_entrega_bairro", { offer_type }),
                        setBairroErrorMessage(null)
                    }}
                />
            </Col>
        </Row>
        <Row>
            <Col width="20%">
                <Select
                        name="uf"
                        type="text"
                        id='uf'
                        options={ufs}
                        onChange={(e) => setUf(e.target.value)}
                        disabled={autoFilled.uf}
                        placeholder="UF"
                        errorMessage={ufErrorMessage}
                        value={uf}
                        OnClick={()=> {
                            events.trigger("endereco_entrega_uf", { offer_type }),
                            setUfErrorMessage(null)
                        }}
                    /> 
            </Col>
            <Col width="80%">
                <InputWithValidation
                    name="cidade"
                    id="cidade"
                    type="text"
                    placeholder="Cidade"
                    onChange={setCidade}
                    value={cidade}
                    disabled={autoFilled.cidade}
                    errorMessage={cidadeErrorMessage}
                    OnClick={()=> {
                        events.trigger("endereco_entrega_cidade", { offer_type }),
                        setCidadeErrorMessage(null)
                    }}
                />
            </Col>
        </Row>
       
        <InputWithValidation
            name="referencia"
            id="referencia"
            type="text"
            maxLenght={25}
            placeholder="Ponto de Referência"
            onChange={setReferencia}
            errorMessage={null}
            value={referencia}
            OnClick={()=> {
                events.trigger("endereco_entrega_ponto_referencia", { offer_type })
            }}
        />
        
        <Select
            name="dica"
            type="text"
            id='dica'
            options={entrega}
            value={entregaSelecionada}
            onChange={(e) => setEntregaSelecionada(e.target.value)}
            placeholder="Dica de entrega"
            OnClick={()=> {
                events.trigger("endereco_entrega_dica_entrega", { offer_type })
            }}
            
        />
    {entregaSelecionada === 'Outros' && 
        <InputWithValidation
            name="descricao"
            id="descricao"
            maxLenght={60}
            type="text"
            placeholder="Descrição"
            onChange={setDescricao}
            errorMessage={null}
            OnClick={()=> {
                events.trigger("endereco_entrega_dica_entrega_descricao", { offer_type })
            }}
            value={descricao}
        />   
    }

        <Button onClick={() => {events.trigger("endereco_entrega_continuar", { offer_type })}} >
            Continuar
        </Button>
    </form>
}

export default Endereco